import DOMPurify from "dompurify";

// Only storefront-safe formatting. PromoStore descriptions are persisted as
// HTML; executable markup, styling, embeds and event handlers are not allowed.
const ALLOWED_TAGS = [
  "p", "div", "br", "strong", "b", "em", "i", "u", "s",
  "h2", "h3", "h4", "ul", "ol", "li", "blockquote",
  "a", "img", "span",
];
const ALLOWED_ATTR = [
  "href", "target", "rel", "title", "src", "alt", "width", "height",
];

export const isPromoStoreDescriptionImageUrl = (value) =>
  /^https?:\/\/[^\s<>"]+$/i.test(String(value || "").trim());

const isAllowedLink = (value) =>
  /^(?:https?:\/\/|mailto:)[^\s<>"]+$/i.test(String(value || "").trim()) ||
  /^\/(?!\/)[^\s<>"]*$/.test(String(value || "").trim());

export const sanitizePromoStoreDescriptionHtml = (value) => {
  const clean = DOMPurify.sanitize(String(value ?? ""), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  });

  if (typeof document === "undefined") return clean;

  const container = document.createElement("div");
  container.innerHTML = clean;
  container.querySelectorAll("img").forEach((image) => {
    const src = image.getAttribute("src") || "";
    if (!isPromoStoreDescriptionImageUrl(src)) image.remove();
  });
  container.querySelectorAll("a").forEach((link) => {
    if (!isAllowedLink(link.getAttribute("href"))) {
      link.replaceWith(document.createTextNode(link.textContent || ""));
    } else if (link.getAttribute("target") === "_blank") {
      link.setAttribute("rel", "noopener noreferrer");
    }
  });
  return container.innerHTML;
};
